import cx from "classnames";
import React, { useState } from "react";
import InfiniteScroll from "react-infinite-scroller";

import Loader from "components/Loader";

interface SlapshotInfiniteScrollProps {
  children: React.ReactElement;
  hasNextPage: boolean;
  useWindow?: boolean;
  isReverse?: boolean;
  loadMore(): void;
  loaderClass?: string;
  threshold?: number;
  className?: string;
}

const SlapshotInfiniteScroll = ({
  children,
  loadMore,
  hasNextPage,
  loaderClass,
  useWindow = false,
  isReverse,
  threshold = 250,
  className,
}: SlapshotInfiniteScrollProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchMore = async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    await loadMore();
    setIsLoading(false);
  };

  return (
    <InfiniteScroll
      pageStart={0}
      useWindow={useWindow}
      initialLoad={false}
      loadMore={fetchMore}
      hasMore={hasNextPage}
      isReverse={isReverse}
      loader={
        <div className={cx("pv3", "mb3", loaderClass)} key={-1}>
          <Loader isLoading={isLoading} />
        </div>
      }
      threshold={threshold}
      className={className}
    >
      {children}
    </InfiniteScroll>
  );
};

export default SlapshotInfiniteScroll;
